export default __webpack_public_path__ + "static/media/loveseat.0907616e.webp";